import React, { useCallback, useState } from "react";

import Address from "@mapmycustomers/shared/types/Address";
import GeoPoint from "@mapmycustomers/shared/types/shapes/GeoPoint";
import getFormattedAddressForUi from "@mapmycustomers/shared/util/formatters/getFormattedAddressForUi";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { AddressPickDetails, AutoCompleteAddressProps, ManualAddress } from "@mapmycustomers/ui";

import SavedLocationsAutoCompleteAddress from "@app/component/savedLocations/SavedLocationsAutoCompleteAddress";
import { SavedLocationSelectSurface } from "@app/util/analytic/savedLocationsAnalytics";

type Props = Pick<
  AutoCompleteAddressProps,
  "error" | "label" | "onReverseGeocodeAddress" | "required"
> & {
  onChange: (address: string, geoPoint?: GeoPoint) => void;
  surface?: SavedLocationSelectSurface;
  value: string;
};

const Location = ({
  error,
  label,
  onChange,
  onReverseGeocodeAddress,
  required,
  surface,
  value,
}: Props) => {
  const [manualAddress, setManualAddress] = useState<Address>();
  const [isManualAddress, switchToManualAddress, , toggleManualAddress] = useBoolean();

  const handleAddressChange = useCallback(
    (address?: Address, details?: AddressPickDetails) => {
      setManualAddress(address);
      onChange?.(getFormattedAddressForUi(address), details?.geoPoint);
    },
    [onChange]
  );

  return isManualAddress ? (
    <ManualAddress
      error={error}
      label={label}
      onChange={handleAddressChange}
      onReverseGeocodeAddress={onReverseGeocodeAddress}
      onToggleManualAddress={toggleManualAddress}
      required={required}
      value={manualAddress}
    />
  ) : (
    <SavedLocationsAutoCompleteAddress
      allowClear
      error={error}
      label={label}
      onChange={handleAddressChange}
      onEnterManually={switchToManualAddress}
      onReverseGeocodeAddress={onReverseGeocodeAddress}
      required={required}
      surface={surface}
      value={{ address: value }}
    />
  );
};

export default Location;
